
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.537 10.638c0 1.024.79 1.843 1.775 1.9 3.245 3.298 7.959 4.359 10.18 4.687-.03.03-.053.048-.053.048L17.275 21 3.966 16.296s-2.558-4.48.65-9.494c3.208-5.013 11.098-5.68 14.436 1.73.03.066.051.123.08.187h-8.718c-1.038 0-1.877.859-1.877 1.92zm3.752 0c0-.027-.014-.048-.015-.074h7.616c.868 2.306 1.122 3.852 1.11 4.866-1.776-.24-6.033-1.078-9.019-3.802.178-.294.308-.62.308-.99z"}})])
          )
        }
      }
    